import React from "react";
import '../../App.css'
import AboutTheTrustCard from "../AboutTheTrustCard";
import Roots from "../Roots";

export default function AboutTheTrust(){
    return (
        <>
            <AboutTheTrustCard />
            <Roots />
        </>

    )
}